import React from 'react';
import { Copy, Check } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { toast } from '@/components/ui/use-toast';
import { useState } from 'react';

interface UniqueIdDisplayProps {
  uniqueId: string;
  className?: string;
}

const UniqueIdDisplay: React.FC<UniqueIdDisplayProps> = ({ uniqueId, className = "" }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async (e: React.MouseEvent) => {
    e.stopPropagation();
    try {
      await navigator.clipboard.writeText(uniqueId);
      setCopied(true);
      toast({
        title: "Copied!",
        description: `ID ${uniqueId} copied to clipboard`,
      });
      setTimeout(() => setCopied(false), 2000);
    } catch (error) {
      toast({
        title: "Copy failed",
        description: "Failed to copy ID to clipboard",
        variant: "destructive",
      });
    }
  };

  return (
    <div className={`flex items-center gap-1 ${className}`}>
      <span className="text-xs text-muted-foreground font-mono bg-muted px-2 py-1 rounded">
        {uniqueId}
      </span>
      <Button
        variant="ghost"
        size="sm"
        onClick={handleCopy}
        className="h-6 w-6 p-0 hover:bg-accent/50"
      >
        {copied ? <Check className="h-3 w-3 text-green-600" /> : <Copy className="h-3 w-3" />}
      </Button>
    </div>
  );
};

export default UniqueIdDisplay;
